import { render, staticRenderFns } from "./bairunCommentStationTag.vue?vue&type=template&id=69fc182c&scoped=true&"
import script from "./bairunCommentStationTag.vue?vue&type=script&lang=js&"
export * from "./bairunCommentStationTag.vue?vue&type=script&lang=js&"
import style0 from "./bairunCommentStationTag.vue?vue&type=style&index=0&id=69fc182c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fc182c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69fc182c')) {
      api.createRecord('69fc182c', component.options)
    } else {
      api.reload('69fc182c', component.options)
    }
    module.hot.accept("./bairunCommentStationTag.vue?vue&type=template&id=69fc182c&scoped=true&", function () {
      api.rerender('69fc182c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/stationManage/bairunComment/bairunCommentStationTag.vue"
export default component.exports